import { render, staticRenderFns } from "./CheckoutCustomerForm.vue?vue&type=template&id=71b71dc9&scoped=true"
import script from "./CheckoutCustomerForm.vue?vue&type=script&lang=js"
export * from "./CheckoutCustomerForm.vue?vue&type=script&lang=js"
import style0 from "./CheckoutCustomerForm.vue?vue&type=style&index=0&id=71b71dc9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b71dc9",
  null
  
)

export default component.exports